import { isHttpClientError } from "../../../lib/http/errors";

/** 格式化人民币金额。 */
export function formatPaymentAmount(value: string | number): string {
  const amount = Number(value);
  return Number.isFinite(amount)
    ? `¥ ${amount.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : "-";
}

/** 格式化银联状态。 */
export function formatPaymentStatus(status: string): string {
  return {
    WAIT_PAY: "待支付",
    WAIT_BUYER_PAY: "待支付",
    PART_PAID: "部分支付",
    SUCCESS: "成功",
    PROCESSING: "处理中",
    PENDING_REVIEW: "待网银审核",
    APPLYING: "开卡申请中",
    APPLY_FAILED: "开卡申请失败",
    FAIL: "失败",
    REFUND_FAIL: "退款失败",
  }[status] ?? status;
}

/** 返回付款记录剩余可退金额。 */
export function refundableAmount(amount: string, refundedAmount: string): number {
  return Math.max(Number(amount) - Number(refundedAmount), 0);
}

/** 把查询错误转换为页面可见提示。 */
export function paymentValidationErrorMessage(error: unknown, fallback: string): string {
  if (isHttpClientError(error) && error.statusCode === 404) {
    return "团编号不存在";
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return fallback;
}
